module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Thêm vận đơn vào đối soát",
      "visible": _vm.dialog
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Chọn file đối soát"
    }
  }, [_c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "id": "fileInput",
      "name": "file"
    },
    on: {
      "change": _vm.loadExcel
    }
  })])], 1), _vm._v(" "), (_vm.fileColumnField.length > 1) ? _c('el-col', [_c('el-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.fileColumnField.length > 1) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("Chọn các cột dữ liệu tương ứng")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "5",
      "border": "0"
    }
  }, [_c('thead', [_c('tr', [_c('td', [_c('strong', [_vm._v("Dữ liệu đầu vào")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Cột tương ứng")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Đơn vị vận chuyển")]), _vm._v(" "), _c('td', [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Chọn cột tương ứng"
    },
    model: {
      value: (_vm.carrier),
      callback: function($$v) {
        _vm.carrier = $$v
      },
      expression: "carrier"
    }
  }, _vm._l((_vm.carriers), function(carrier) {
    return _c('el-option', {
      key: carrier.id,
      attrs: {
        "label": carrier.name,
        "value": carrier.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _vm._l((_vm.filteredFileColumnField), function(field, index) {
    return _c('tr', {
      key: 'row-' + index
    }, [_c('td', [_vm._v(_vm._s(field.text))]), _vm._v(" "), _c('td', [_c('el-select', {
      attrs: {
        "placeholder": "Chọn cột tương ứng"
      },
      model: {
        value: (_vm.filteredFileColumnField[index].file),
        callback: function($$v) {
          _vm.$set(_vm.filteredFileColumnField[index], "file", $$v)
        },
        expression: "filteredFileColumnField[index].file"
      }
    }, _vm._l((_vm.fileColumnField), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.text,
          "value": item.value
        }
      })
    }), 1)], 1)])
  })], 2)])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Hủy bỏ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitting,
      "disabled": _vm.dataExcelJson.length === 0
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("Tải lên")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34c496e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compare/DialogAddShipmentToCompare.vue
// module id = 636
// module chunks = 1